import { render, staticRenderFns } from "./UCStoryblokImage.vue?vue&type=template&id=07a1a690&scoped=true&"
import script from "./UCStoryblokImage.vue?vue&type=script&lang=ts&"
export * from "./UCStoryblokImage.vue?vue&type=script&lang=ts&"
import style0 from "./UCStoryblokImage.vue?vue&type=style&index=0&id=07a1a690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a1a690",
  null
  
)

export default component.exports